import { render, staticRenderFns } from "./DatasetAudioCategorization.vue?vue&type=template&id=8396c474&scoped=true&"
import script from "./DatasetAudioCategorization.vue?vue&type=script&lang=js&"
export * from "./DatasetAudioCategorization.vue?vue&type=script&lang=js&"
import style0 from "./DatasetAudioCategorization.vue?vue&type=style&index=0&id=8396c474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8396c474",
  null
  
)

export default component.exports